import React from "react";
import { Link } from "react-router-dom";

const tabs = [
    { label: "Dock Master", to: "/dockmaster", key: "dock" },
    { label: "Vehicle Type", to: "/vehicletype", key: "vehicle" },
    { label: "Customer", to: "/customer", key: "customer" },
    { label: "Transporters", to: "/transporter", key: "transporter" },
    { label: "Vendors", to: "/vendor", key: "vendor" },
    { label: "Product Type", to: "/product", key: "product" },
    { label: "Auto Report Trigger", to: "/autotrigger", key: "autotrigger" },
    { label: "Alert Configurations", to: "/alertconfigurations", key: "alertconfigurations" },
    { label: "Config Fields", to: "/registerfields", key: "registerfields" },

];

const CustomerTabs = ({ activeTab, setActiveTab }) => {
    return (
        <div className="customer-tabs">
            {tabs.map(({ label, to, key }) => (
                <Link
                    key={key}
                    to={to}
                    className={`customer-tab ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                >
                    {label}
                </Link>
            ))}
        </div>
    );
};

export default CustomerTabs;
